import { Component } from '@angular/core';
import { NavController, ModalController, ToastController, LoadingController,NavParams } from 'ionic-angular';

import { Master  } from '@providers/asset/index';

@Component({
  selector: 'page-form_classification',
  templateUrl: 'page.html'
})
export class FormClassificationPage {

  item = {
    id: '',
    classification_name: '',
    classification_code: '',
    parent_id: '',
    description: '',
    level_id: '',
  };

  constructor(
    public MasterApi: Master,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController, 
    navParams: NavParams
  ) {
    if(navParams.get('parent_id')!=undefined){
      this.item.parent_id = navParams.get('parent_id');
    }

    if(navParams.get('item')!=undefined){
      this.item = navParams.get('item');
    }
  }
  
  simpan(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = this.item;
    this.MasterApi.saveClassification(params).subscribe((resp:any) => {
      this.item.id = resp.data.id;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/form_classification/page.ts